module.exports = __webpack_public_path__ + "img/firefox-logo.f296a485.svg";